import { debugLog } from '../utils/logging/debugLog';
export const API_BASE = process.env.REACT_APP_BACKEND_URL;
debugLog('📡 Using API base URL:', API_BASE);
